"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorHandling = exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var Types = require("types");
var avatars_1 = require("components/Avatar/avatars");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
require("./style.scss");
var mapStateToProps = function (_a) {
    var files = _a.files;
    return {
        status: files.data.status,
        error: files.data.status === 'FAILED' ? files.data.error : undefined
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({}); };
exports.mapDispatchToProps = mapDispatchToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), recompose_1.pure);
exports.ErrorHandling = enhance(function (props) {
    if (props.status === 'FAILED' && props.error) {
        if (props.error.type === 'PERMISSION_DENIED') {
            return (React.createElement("div", { className: 'files-view-folder-permisssion-denied' },
                React.createElement("span", null,
                    React.createElement("img", { src: (0, avatars_1.getAvatarUrl)('Grano_SokoPro_avatar_19'), width: 200, height: 200 })),
                React.createElement("span", null, (0, translation_1.getLocalization)('global/dearSokoProUser')),
                React.createElement("span", null, (0, translation_1.getLocalization)('filestab/error/accessDenied1')),
                React.createElement("span", null, (0, translation_1.getLocalization)('filestab/error/accessDenied2'))));
        }
        if (props.error.type === 'NOT_FOUND') {
            return (React.createElement("div", { className: 'notfound' }, (0, translation_1.getLocalization)('filestab/error/folderNotFound')));
        }
        if (props.error.type === 'UNKNOWN_ERROR') {
            return (React.createElement("div", { className: 'files-view-folder-permisssion-denied' },
                React.createElement("span", null,
                    React.createElement("img", { src: (0, avatars_1.getAvatarUrl)('Grano_SokoPro_avatar_19'), width: 200, height: 200 })),
                React.createElement("span", null, (0, translation_1.getLocalization)('global/dearSokoProUser')),
                React.createElement("span", null, (0, translation_1.getLocalization)('filestab/error/sometingWentWrong')),
                React.createElement("span", null, (0, translation_1.getLocalization)('global/tryAgain'))));
        }
    }
    return null;
});
